var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03033 1.53033C4.32322 1.23744 4.32322 0.762563 4.03033 0.46967C3.73744 0.176777 3.26256 0.176777 2.96967 0.46967L0.96967 2.46967C0.676777 2.76256 0.676777 3.23744 0.96967 3.53033L2.96967 5.53033C3.26256 5.82322 3.73744 5.82322 4.03033 5.53033C4.32322 5.23744 4.32322 4.76256 4.03033 4.46967L3.31066 3.75L13 3.75C13.4142 3.75 13.75 3.41421 13.75 3C13.75 2.58579 13.4142 2.25 13 2.25L3.31066 2.25L4.03033 1.53033ZM15.0303 4.46967C14.7374 4.17678 14.2626 4.17678 13.9697 4.46967C13.6768 4.76256 13.6768 5.23744 13.9697 5.53033L14.6893 6.25L5 6.25C4.58579 6.25 4.25 6.58579 4.25 7C4.25 7.41421 4.58579 7.75 5 7.75L14.6893 7.75L13.9697 8.46967C13.6768 8.76256 13.6768 9.23744 13.9697 9.53033C14.2626 9.82322 14.7374 9.82322 15.0303 9.53033L17.0303 7.53033C17.3232 7.23744 17.3232 6.76256 17.0303 6.46967L15.0303 4.46967Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.aa68ad836fac577865124d0c99f48a17.svg";
export { ForwardRef as ReactComponent };